module.exports = __webpack_public_path__ + "static/media/notifications-bell.0cb2b6b1.png";